module.exports = __webpack_public_path__ + "img/DSC_2940-xl.414796f4.png";